import { useState } from 'react'
import { ChildProfileModal } from '../members/ChildProfileModal'
import { MemberProfileModal } from '../members/MemberProfileModal'

export interface CompetitorTarget {
  userId: string
  /** Set when the competitor is a child's own login. */
  childId: string | null
}

interface Props {
  target: CompetitorTarget
  onClose: () => void
}

/**
 * The profile behind a competitor row.
 *
 * A competitor is an account, and an account can be a child's own login. Opening
 * that as a member profile shows a stand-alone adult with no plan and no
 * history, which is wrong twice over: the plan, the check-ins and the parent all
 * live on the child. So a child opens as a child, and the parent is one tap away.
 */
export function CompetitorProfileModal({ target, onClose }: Props) {
  // From the child's modal, staff can step across to the parent.
  const [parentId, setParentId] = useState<string | null>(null)

  if (parentId) return <MemberProfileModal userId={parentId} onClose={onClose} />
  if (target.childId)
    return (
      <ChildProfileModal childId={target.childId} onClose={onClose} onOpenParent={setParentId} />
    )
  return <MemberProfileModal userId={target.userId} onClose={onClose} />
}
